import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import {
  CallLogsHoc,
  NewChatHoc,
  DotMenuHoc,
  NewGroupHoc,
  // IconArchiveHoc,
  // SettingsHoc,
  IconDarkThemeHoc,
  IconLightThemeHoc,
  LogoutHoc,
  SettingsHoc,
} from "../../assets/images";
import RecentChatSection from "../WebChat/RecentChatSection";
import WebChatVCard from "../WebChat/WebChatVCard/WebChatVCard";
import WebChatRoster from "../WebChat/WebChatRoster.js";
import CustomIcon from "../../assets/images/CustomIcon";
import { useSelector } from "react-redux";
import  ColorThemeEngine from "../../initial/ColorThemeEngine";
import { updateTheme } from "../../Redux/feature/themeDataSlice";
import { store } from "../../Redux/store";
import CreateNewGroup from '../WebChat/NewGroup/index';
import SDK from "../../SDK";
import { resetSingleChatSelectedMedia } from "../../Redux/feature/singleChatSelectedMediaSlice";
import { logOutActiveChatData } from "../../Redux/feature/activeChatDataSlice";
import { logOutRecentChat } from "../../Redux/feature/recentChatDataSlice";
import WebChatCallLogs from "../WebCall/WebChatCallLogs";
import ParticipantsPopUp from "../ContactInfo/ParticipantsPopUp";
import ActionPopUp from "../ContactInfo/ActionPopUp";
import CallParticipantsPopup from '../WebCall/ParticipantPopUp';
import { CALL_CONVERSION_STATUS_ACCEPT, CALL_CONVERSION_STATUS_CANCEL, CALL_CONVERSION_STATUS_DECLINE, CALL_CONVERSION_STATUS_REQUEST, CALL_CONVERSION_STATUS_REQ_WAITING } from "../../Helpers/Call/Constant";
import CallConversionPopup from "../WebCall/CallConversionPopup";
import callLogsObj from '../WebCall/CallLogs/callLog';
import { fetchingCallLog } from "../../Redux/feature/calllogsDataSlice";
import { encryptAndStoreInLocalStorage } from "../../Helpers/Chat/webChatEncryptDecrypt";
import Setting from "../WebChat/Setting";
import { logOutChatConversation } from "../../Redux/feature/chatConversationHistorySlice";
import ActionInfoPopup from "../ActionInfoPopup";
import { disconnectCallConnection } from "../../Helpers/Call/Call";
import { addCallIntermediate } from "../../Redux/feature/callIntermediateScreenSlice";
import { resetConferenceData } from "../../Redux/feature/showConfrenceDataSlice";

const Sidebar = (props = {}) => {
  const {
    // isEnableArchived = false,
    callUserJID,
    callStatus,
    callLogCount = 0,
    callType,
    callMode,
    handlePopupState = () => { },
    handleShowCallScreen = () => { },
    logout,
    isCallEnabled
  } = props;
  const globalState = useSelector(state => state);
  const { popUpData:{ modalProps: { open, modelType, newCallLink } }, callConversionData, browserNotify, dynamicIcon:{ data } } = globalState 
  const { appOnlineStatus : {isAppOnline} } = globalState
  const {
    mf_CallLogs,
    mf_NewChat,
    mf_DotMenu,
    mf_NewGroup,
    // mf_IconArchive,
    mf_Settings
  } = data
  const { themeData : { theme:stateTheme } , vCardData = {}, rosterData = {},
  featureFlagList:{data:featureStateData = {}},
          featureFlagList:{data:{ 
                              isGroupChatEnabled=false,
                              isRecentChatSearchEnabled=false,
                              isOneToOneCallEnabled= false,     
                            }}={} } = globalState;
  const [menuDropDownStatus, setmenuDropDownStatus] = React.useState(false);
  const [newChatStatus, setNewChatStatus] = React.useState(true);
  const [callLogs, setcallLogs] = React.useState(false);
  const [currentUserRequestingCallSwitch, setCurrentUserRequestingCallSwitch] = React.useState(false);
  const [remoteUserRequestingCallSwitch, setremoteUserRequestingCallSwitch] = React.useState(false);
  const [getCreatenewGroup, setCreatenewGroup] = React.useState(false);
  const [settingStatus,setSettingStatus] = React.useState(false);
  const [theme, setTheme] = React.useState(stateTheme === "dark" ? "light" : "dark");
  const handleCallLogs = () => {
    setNewChatStatus({ newChatStatus: false });
    setcallLogs(true);
    store.dispatch(fetchingCallLog(true));
    callLogsObj.getCallLogsFromServer(1);
  };

  const resetCallConversionRequestData = () => {
    setCurrentUserRequestingCallSwitch(false);
    setremoteUserRequestingCallSwitch(false);
  }

  React.useEffect(()=>{
    setTheme(stateTheme === "dark" ? "light" : "dark")
  },[stateTheme])

  React.useEffect(()=>{
    if (globalState?.callConversionData && globalState?.callConversionData?.data?.status) {
      if (callConversionData?.data?.status === CALL_CONVERSION_STATUS_ACCEPT) {
          if (remoteUserRequestingCallSwitch === true && currentUserRequestingCallSwitch === true) {
            setCurrentUserRequestingCallSwitch(false);
          }
          setremoteUserRequestingCallSwitch(false);
      } else if (callConversionData?.data?.status === CALL_CONVERSION_STATUS_REQ_WAITING) {
        setCurrentUserRequestingCallSwitch(true);
      } else if (callConversionData?.data?.status === CALL_CONVERSION_STATUS_REQUEST) {
        setremoteUserRequestingCallSwitch(true);
      } else if (callConversionData?.data?.status === CALL_CONVERSION_STATUS_CANCEL) {
          resetCallConversionRequestData();
      } else if (callConversionData?.data?.status === CALL_CONVERSION_STATUS_DECLINE) {
          resetCallConversionRequestData();
      }
  }
  },[callConversionData])  

  const handleBackFromCallLogs = (status) => {
    setNewChatStatus({ newChatStatus: status });
    setcallLogs(false);
  }

  const handleNewChat = () => {
    setNewChatStatus(false);
    setmenuDropDownStatus(false);
  };
  const outsidePopupClick = () => {
    if (open) {
        return;
    }
    setmenuDropDownStatus(false);
  };
  const handleBackStatus = () => {
    setNewChatStatus(true);
  };
  const handleCreateNewGroup = () => {
    setCreatenewGroup(true);
    setmenuDropDownStatus(!menuDropDownStatus);
  };
  const handleArchivedChatList = () => {
    console.log("handleArchivedChatList");
  };

  const handleSetting = () => {
    setSettingStatus(true)
  };

  const handleBackFromSetting = () => {
    setSettingStatus(false)
  }

  const handleLogout = () =>{
    localStorage.clear();
    SDK.logout();
    store.dispatch(resetSingleChatSelectedMedia());
    store.dispatch(logOutActiveChatData());
    store.dispatch(logOutRecentChat());
    store.dispatch(logOutChatConversation());
    logout();
  }

  const handleTheme = () => {
    outsidePopupClick()
    if(theme === 'dark'){
      encryptAndStoreInLocalStorage("themeMode", "dark")
      setTheme("light")
      ColorThemeEngine("dark")
      store.dispatch(updateTheme("dark"))
    }else{
      encryptAndStoreInLocalStorage("themeMode", "light")
      setTheme("dark")
      ColorThemeEngine("light") 
      store.dispatch(updateTheme("light"))
    }
  };

  const handleMenuDrop = () => {
    setmenuDropDownStatus(!menuDropDownStatus);
  };

  const closeModel = (modelType) => {
    store.dispatch(
      showModal({
          open: false,
          modelType
      })
    );
  }

  const handleJoinCallAction = () => {
    encryptAndStoreInLocalStorage("isNewCallExist", true);
    disconnectCallConnection();
    store.dispatch(resetConferenceData());
    closeModel("CallConfirm");
    const newLink = newCallLink
    setTimeout(() => {
        store.dispatch(addCallIntermediate({ show: true, link: newLink }));
    }, 10);
  };

  const handleCancel = () => {
    closeModel("CallConfirm");
  };

  /**
   * const handleConversationSectionDisplay = () => {};
   */  

  const handleBackToRecentChat = () => {
    setmenuDropDownStatus(false);
    setCreatenewGroup(false);
  };

  const browserNotifyRedirect = () => {
    // When click on missed call notification, need to redirect to calllog page
    // We check the browserNotify pageName is 'calllog', then swith the page to calllog
    // const prevPropsBrowserNotifyData = prevProps.browserNotifyData;
    // const browserNotifyData = this.props.browserNotifyData;
    if (browserNotify.data &&
        browserNotify.data === 'calllog'
    ) {
        handleCallLogs()
    }
  }

  React.useEffect(()=>{
    browserNotifyRedirect()
  },[browserNotify])

  const renderRecentChat = (pageType) => {
    return (
      <RecentChatSection
        pageType={pageType}
        handleBackStatus={handleBackStatus}
        callUserJID={callUserJID}
        callStatus={callStatus}
        newChatStatus={newChatStatus}
        handleShowCallScreen={handleShowCallScreen}
        callType={callType}
        callMode={callMode}
        handlePopupState={handlePopupState}
        handleArchivedChatList={handleArchivedChatList}
        searchFlag = {isRecentChatSearchEnabled}
      />
    );
  };

  return (
    <>
    <div className="recent-chatlist">
      {/* <OutsideClickHandler onOutsideClick={() => outsidePopupClick()} > */}
        {newChatStatus && (
          <>
          <OutsideClickHandler onOutsideClick={() => outsidePopupClick()} >
            <div className="recent-chatlist-header">
              <WebChatVCard handleBack={handleBackToRecentChat}/>              
              <div className="profile-options">
              {/* <OutsideClickHandler onOutsideClick={() => outsidePopupClick()} > */}
              {
                    isCallEnabled &&
                <i
                  className="callLogs"
                  onClick={handleCallLogs}
                  title="Call logs"
                >
                  {isOneToOneCallEnabled && callLogCount ? (
                    <div className="callLogCount">
                      <CustomIcon icon={mf_CallLogs ? mf_CallLogs : <CallLogsHoc viewBox="0 0 24.037 24"/>} {...props} />
                      <span style={{ display: "none" }}>{callLogCount}</span>
                    </div>
                  ) : (
                      <CustomIcon icon={mf_CallLogs ? mf_CallLogs : <CallLogsHoc  viewBox="0 0 24.037 24" />} {...props} />
                    )}
                </i>
                }
                <i
                  className="newchat-icon"
                  onClick={() => handleNewChat()}
                  title="New chat"
                >
                  <span className="toggleAnimation"></span>
                  <CustomIcon icon={mf_NewChat ? mf_NewChat : <NewChatHoc viewBox="0 0 20.978 20.348"/>} {...props} />                
                </i>
                <i
                  className={
                    menuDropDownStatus ? "menu-icon open" : "menu-icon"
                  }
                  onClick={() => handleMenuDrop()}
                  title="More options"
                >
                  <span className="toggleAnimation"></span>
                  <CustomIcon icon={mf_DotMenu ? mf_DotMenu : <DotMenuHoc  viewBox="0 0 24 24" />} {...props} />
                </i>
                {/* </OutsideClickHandler> */}
              </div>
              
              {menuDropDownStatus ? (
                <>
                  {/* <OutsideClickHandler
                    onOutsideClick={() => outsidePopupClick()}
                  > */}
                    <ul className="menu-dropdown open">
                      { isGroupChatEnabled && (
                      <li title="New Group" onClick={handleCreateNewGroup}>
                        <i>
                          <CustomIcon icon={mf_NewGroup ? mf_NewGroup : <NewGroupHoc viewBox="0 0 13.999 13.999"/>} {...props} />
                        </i>
                        <span>New Group</span>
                      </li>)
                      }
                      {/* {!isEnableArchived && ( */}
                        {/* <li */}
                          {/* title="Archived Chats" */}
                          {/* onClick={handleArchivedChatList} */}
                        {/* > */}
                          {/* <i> */}
                          {/* <CustomIcon */}
                            {/* icon={mf_IconArchive ? mf_IconArchive : <IconArchiveHoc viewBox="0 0 15 15.668"/>} */}
                            {/* {...props} */}
                          {/* /> */}
                          {/* </i> */}
                          {/* <span>Archived</span>
                        </li>
                      )} */}
                      
                      {
                       isCallEnabled &&
                      <li title="Settings" onClick={() => handleSetting()}>
                        <i>
                        <CustomIcon icon={mf_Settings ? mf_Settings : <SettingsHoc viewBox="0 0 14 14"/>} {...props} />
                        </i>
                        <span>Settings</span>
                      </li>
                      }
                      <li title="Themes" onClick={handleTheme}>
                      {theme === 'dark' ?
                      <i>
                      <CustomIcon icon={<IconDarkThemeHoc viewBox="0 0 24 24"/>} {...props} />
                      </i>
                        :
                        <i>
                        <CustomIcon icon={<IconLightThemeHoc viewBox="0 0 24 24"/>} {...props} />
                        </i>
                      }
                        <span>{theme} Theme</span>
                      </li>
                      <li title="Log Out" onClick={handleLogout}>
                        <i>
                        <CustomIcon icon={mf_Settings ? mf_Settings : <LogoutHoc viewBox="0 0 12.997 14.1"/>} {...props} />
                        </i>
                        <span>Log Out</span>
                      </li>

                    </ul>
                  {/* </OutsideClickHandler> */}
                </>
              ) : null}
            </div>
            </OutsideClickHandler>
          </>
        )}
        {renderRecentChat("recent")}
        {!newChatStatus && (
          <WebChatRoster
            newChatStatus={newChatStatus}
            handleBackStatus={handleBackStatus}
          />
        )}
      {/* </OutsideClickHandler> */}
      {getCreatenewGroup &&
        <CreateNewGroup
          rosterData={rosterData}
          vCardData={vCardData}
          handleBackToRecentChat={handleBackToRecentChat}
        />
      }
      {
        callLogs && <WebChatCallLogs handleBackStatus={handleBackFromCallLogs} handleContactPermissionPopup={props.handleContactPermissionPopup}/>
      }
      {settingStatus &&
        <Setting
          handleBackFromSetting={handleBackFromSetting}
          // logoutStatus={this.handleLogutStatus}
          featureStateData={featureStateData}
        />
      }
    </div>
    {open && modelType === 'action' && <ActionPopUp {...globalState.popUpData} />}
    {open && modelType === 'participants' && <ParticipantsPopUp />}
    {open && ['callparticipants', 'inviteParticipants', 'calllogparticipants'].indexOf(modelType) > -1 && <CallParticipantsPopup />}
    {callConversionData?.data?.status && isAppOnline &&
      <CallConversionPopup
        callConversionData={callConversionData}
        resetCallConversionRequestData={resetCallConversionRequestData}
        currentUserRequestingCallSwitch={currentUserRequestingCallSwitch}
        remoteUserRequestingCallSwitch={remoteUserRequestingCallSwitch}
      />
    }
    {open && modelType === "CallConfirm" && (
      <Modal containerId="container">
          <ActionInfoPopup
              handleActionText={"Ok"}
              handleCancelText={"Cancel"}
              handleAction={() => handleJoinCallAction()}
              handleCancel={() => handleCancel()}
              textHeading={"You're already in a call"}
              text={"Do you want to leave your call to join this one?"}
          />
      </Modal>
    )}
    </>
  );
};

export default Sidebar;
